import $ from "jquery";
import 'slick-carousel';

// Nieuwe slick_init functie
export function slick_init() {
	const slickMain = $('.js-slick');
	const slickStats = $('.js-slick-stats');
	const slickTease = $('.js-slick-tease');
	const slickLogos = $('.js-slick-logos');
	
	let resizeTimer;

	function initSlick(element, settings) {
		if (element.hasClass('slick-initialized')) {
			element.slick('unslick');
		}
		element.slick(settings);
	}

	const mainSettings = {
		autoplay: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: true,
		swipe: false,
		dots: true,
		centerMode: true,
		swipeToSlide: true,
		pauseOnHover: false,
		speed: 1000,
		autoplaySpeed: 5000,
		cssEase: 'cubic-bezier(.19,1,.22,1)',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					fade: true,
					arrows: false,
					swipe: true,
					autoplay: false
				}
			}
		]
	};

	const statsSettings = {
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		dots: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	};
	
	const teaseSettings = {
		slidesToShow: 3,
		slidesToScroll: 1,
		leftAlign: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			}
		]
	};

	const logosSettings = {
		autoplay: true,
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 5,
		arrows: true, // Alleen aanzetten, styling gebeurt via SCSS
		swipe: true,
		dots: false,
		centerMode: true,
		swipeToSlide: true,
		pauseOnHover: false,
		speed: 500,
		autoplaySpeed: 3000,
		cssEase: 'ease-out',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	};



	function resizeHandler() {
		initSlick(slickMain, mainSettings);
		initSlick(slickTease, teaseSettings);
		initSlick(slickLogos, logosSettings);
		slickStats.each(function() {
			initSlick($(this), statsSettings);
		});
	}

	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(resizeHandler, 1400);
	});

	// Initial load
	resizeHandler();
}

$(document).ready(function() {
	slick_init();
});